// material-ui
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function Footer() {
	return (
		<Stack
			direction="row"
			sx={{ alignItems: "center", justifyContent: "space-between", p: "24px 16px 0px", mt: "auto" }}
		>
			<Typography variant="caption">
				&copy; All rights reserved{" "}
				<Link
					href={import.meta.env.VITE_REACT_APP_TECHWIZE_SITE_LINK}
					target="_blank"
					underline="hover"
				>
					Techwize
				</Link>
			</Typography>
			<Stack
				direction="row"
				sx={{ gap: 1.5, alignItems: "center", justifyContent: "space-between" }}
			>
				{/* <Link
					href={`${import.meta.env.VITE_REACT_APP_TECHWIZE_SITE_LINK}/discover-techwize`}
					target="_blank"
					variant="caption"
					underline="hover"
				>
					About us
				</Link> */}
				<Link
					href={`${import.meta.env.VITE_REACT_APP_TECHWIZE_AI_SITE_PRIVACY_POLICIES}`}
					target="_blank"
					variant="caption"
					color="text.primary"
				>
					Privacy
				</Link>
				<Link
					href={`${import.meta.env.VITE_REACT_APP_TECHWIZE_AI_SITE_TERMS_CONDITIONS}`}
					target="_blank"
					variant="caption"
					color="text.primary"
				>
					Terms
				</Link>
			</Stack>
		</Stack>
	);
}
